import { ApplicationStatus } from "shared/types";
import { ApplicantRoleLabel } from "shared/utils";
import { RoleTitles } from "views/settings-users/constants";

export const applicationDecisionStatus = {
  [ApplicationStatus.Rejected]: "Application rejected",
  [ApplicationStatus.Approved]: "Application approved",
  [ApplicationStatus.ConditionalApproved]: "Application approved conditionally"
};

export const combinedRoles = {
  ...RoleTitles,
  ...ApplicantRoleLabel
};
